import { Directive, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[min][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMinDirective, multi: true}],
  standalone: false,
})
export class CustomMinDirective implements Validator {
  @Input()
  min: number;

  validate(c: UntypedFormControl): {[key: string]: any} {
      let v = c.value;
      return ( v < this.min)? {"min": true} : null;
  }
}
